import { Card, Col, Row, Button, } from "antd";
import React from "react";

import { PlusCircleFilled } from '@ant-design/icons';
import { useNavigate } from "react-router-dom";

import "./UpcomingActivities.css";

function UpcomingActivities() {
  const navigate = useNavigate();
  const mainHeaderButtons = (
    <Button className='headerButtons' size='small' icon={<PlusCircleFilled />} onClick={() => navigate("/add-new-activity")}>Add Activity</Button>
  );

  return (
    <Row className="upcoming-activities">
      <Col span={24}>
        <Card title="Upcoming Activities" extra={mainHeaderButtons}>
          <hr />
          <p>There are no activities at this time</p>
        </Card>
      </Col>
    </Row>
  );
}

export default UpcomingActivities;
